import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {AuthenticationService} from '../shared/service/authentication.service';
import {Urls} from './url';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('geonames')) {
      const credentials = this.authenticationService.getCredentials();
      const newReq = credentials ? req.clone({
        setHeaders: {
          authorization: credentials
        },
        url: Urls.getBaseUrlApi() + req.url
      }) : req.clone({
        url: Urls.getBaseUrl() + req.url
      });
      return next.handle(newReq);
    }
    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/core/token-interceptor.ts